import React, { Component } from 'react';
import './details.scss';
import { ImageViewer } from 'antd-mobile-v5';
import Axios from 'axios';

const MANUAL_ASSET_ROOT = 'http://spt.joymeter.com/image';
const INSTRUCTIONS_NO_PATTERN = /^[A-Za-z0-9][A-Za-z0-9._-]*$/;
const MANIFEST_VERSION = 1;

class Details extends Component {
  constructor(props) {
    super(props);
    this.state = {
      images: [],
      loading: true,
      error: '',
      failedImages: {},
      previewImage: ''
    };
    this.requestSource = null;
  }

  componentDidMount() {
    this.loadManual();
  }

  componentWillUnmount() {
    if (this.requestSource) {
      this.requestSource.cancel('Manual page unmounted');
    }
  }

  loadManual = () => {
    const code = new URLSearchParams(window.location.search).get('code');

    document.title = (code && code.endsWith('-en')) ? 'User Manual' : '产品说明';

    if (!code) {
      this.setState({
        images: [],
        loading: false,
        error: '缺少说明书编号，请检查访问链接。'
      });
      return;
    }

    if (!INSTRUCTIONS_NO_PATTERN.test(code)) {
      this.setState({
        images: [],
        loading: false,
        error: '说明书编号格式不正确，请检查访问链接。'
      });
      return;
    }

    if (this.requestSource) {
      this.requestSource.cancel('Reload manual');
    }
    this.requestSource = Axios.CancelToken.source();

    this.setState({
      images: [],
      loading: true,
      error: '',
      failedImages: {},
      previewImage: ''
    });

    const manualRoot = `${MANUAL_ASSET_ROOT}/${encodeURIComponent(code)}`;

    Axios({
      url: `${manualRoot}/manifest.json`,
      method: 'GET',
      cancelToken: this.requestSource.token
    }).then((res) => {
      const manifest = res.data;
      const pagePattern = new RegExp(`^${code.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}[-_]\\d+\\.jpg$`);
      const pages = manifest && Array.isArray(manifest.pages)
        ? manifest.pages.filter((page) => typeof page === 'string' && pagePattern.test(page))
        : [];
      const pagesAreContinuous = pages.every((page, index) => {
        const pageNumber = String(index + 1);
        const paddedPageNumber = pageNumber.padStart(2, '0');
        return page === `${code}-${paddedPageNumber}.jpg`
          || page === `${code}_${paddedPageNumber}.jpg`
          || page === `${code}-${pageNumber}.jpg`
          || page === `${code}_${pageNumber}.jpg`;
      });
      const manifestIsValid = manifest
        && manifest.version === MANIFEST_VERSION
        && manifest.instructionsNo === code
        && Array.isArray(manifest.pages)
        && pages.length === manifest.pages.length
        && pages.length > 0
        && pagesAreContinuous;

      if (manifestIsValid) {
        this.setState({
          images: pages.map((page) => `${manualRoot}/${encodeURIComponent(page)}`),
          loading: false,
          error: ''
        });
        return;
      }

      this.setState({
        images: [],
        loading: false,
        error: '说明书清单格式不正确，请联系管理员。'
      });
    }).catch((error) => {
      if (Axios.isCancel(error)) {
        return;
      }
      const notFound = error.response && error.response.status === 404;
      this.setState({
        images: [],
        loading: false,
        error: notFound
          ? '未找到对应的产品说明书。'
          : '说明书加载失败，请检查网络后重试。'
      });
    });
  }

  handleImageError = (index) => {
    this.setState((state) => ({
      failedImages: {
        ...state.failedImages,
        [index]: true
      }
    }));
  }

  retryImage = (index) => {
    this.setState((state) => {
      const failedImages = { ...state.failedImages };
      delete failedImages[index];
      return { failedImages };
    });
  }

  openPreview = (image) => {
    this.setState({ previewImage: image });
  }

  closePreview = () => {
    this.setState({ previewImage: '' });
  }

  renderStatus() {
    const { loading, error } = this.state;

    if (loading) {
      return (
        <div className="manual-status" role="status" aria-live="polite">
          <span className="manual-status__spinner" aria-hidden="true" />
          <p>正在加载说明书…</p>
        </div>
      );
    }

    if (error) {
      return (
        <div className="manual-status" role="alert">
          <div className="manual-status__icon" aria-hidden="true">!</div>
          <p>{error}</p>
          <button type="button" onClick={this.loadManual}>重新加载</button>
        </div>
      );
    }

    return null;
  }

  render() {
    const { images, loading, error, failedImages, previewImage } = this.state;

    if (loading || error) {
      return <main className="manual-page">{this.renderStatus()}</main>;
    }

    return (
      <main className="manual-page">
        <div className="manual-page__summary">
          共 {images.length} 页 · 点击图片可放大
        </div>

        <div className="manual-page__pages">
          {images.map((image, index) => (
            <figure className="manual-page__item" key={image}>
              {failedImages[index] ? (
                <div className="manual-image-error" role="alert">
                  <span>第 {index + 1} 页加载失败</span>
                  <button type="button" onClick={() => this.retryImage(index)}>重试</button>
                </div>
              ) : (
                <img
                  src={image}
                  alt={`说明书第 ${index + 1} 页`}
                  loading={index === 0 ? 'eager' : 'lazy'}
                  decoding="async"
                  onClick={() => this.openPreview(image)}
                  onError={() => this.handleImageError(index)}
                />
              )}
            </figure>
          ))}
        </div>

        <div className="manual-page__end">已浏览全部内容</div>

        <ImageViewer
          image={previewImage}
          visible={Boolean(previewImage)}
          onClose={this.closePreview}
        />
      </main>
    );
  }
}

export default Details;
